(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-complaint"] && !Shopify.designMode) return;
  try {
    
  const form = document.getElementById('gb-complaint-form');
  if (form) {
    form.addEventListener('submit', () => {
      const body = form.querySelector('[name="contact[body]"]');
      if (!body || body.value.indexOf('Plainte produit') !== -1) return;
      const product = form.querySelector('[name="contact[Produit]"]');
      const issue = form.querySelector('[name="contact[Type de probleme]"]');
      const place = form.querySelector('[name="contact[Lieu dachat]"]');
      const date = form.querySelector('[name="contact[Date dachat]"]');
      const lot = form.querySelector('[name="contact[Numero de lot]"]');
      const meta = [
        'Plainte produit',
        product && product.value ? 'Produit: ' + product.value : '',
        issue && issue.value ? 'Type: ' + issue.value : '',
        place && place.value ? 'Lieu: ' + place.value : '',
        date && date.value ? 'Date: ' + date.value : '',
        lot && lot.value ? 'Lot: ' + lot.value : ''
      ].filter(Boolean).join('\n');
      body.value = meta + '\n\n' + body.value;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-contact"] && !Shopify.designMode) return;
  try {
    
  const form = document.getElementById('gb-contact-form');
  if (form) {
    form.addEventListener('submit', () => {
      const body = form.querySelector('[name="contact[body]"]');
      const topic = form.querySelector('[name="contact[Sujet]"]');
      if (typeof window.gbAcSubmit !== 'function') return;
      window.gbAcSubmit({
        source: 'consumer',
        email: form.querySelector('[name="contact[email]"]')?.value,
        fullname: form.querySelector('[name="contact[name]"]')?.value,
        phone: form.querySelector('[name="contact[phone]"]')?.value,
        topic: topic && topic.value ? topic.options[topic.selectedIndex].text : '',
        message: body ? body.value : '',
      }).catch(() => {});
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-retailer"] && !Shopify.designMode) return;
  try {
    
  const form = document.getElementById('gb-retailer-form');
  if (form) {
    const selectAll = form.querySelector('[data-gb-select-all]');
    const productBoxes = form.querySelectorAll('input[name="contact[Produits]"]');
    const syncSelectAll = () => {
      if (!selectAll) return;
      const total = productBoxes.length;
      const on = [...productBoxes].filter((el) => el.checked).length;
      selectAll.checked = total > 0 && on === total;
    };
    if (selectAll) {
      selectAll.addEventListener('change', () => {
        productBoxes.forEach((el) => {
          el.checked = selectAll.checked;
        });
      });
      productBoxes.forEach((el) => el.addEventListener('change', syncSelectAll));
    }

    form.addEventListener('submit', () => {
      const val = (selector) => form.querySelector(selector)?.value?.trim() || '';
      const label = (select) => {
        if (!select || !select.value) return '';
        return select.options[select.selectedIndex].text;
      };
      const products = [...form.querySelectorAll('input[name="contact[Produits]"]:checked')]
        .map((el) => el.value)
        .join(', ');
      let list = form.querySelector('[data-gb-product-list]');
      if (!list) {
        list = document.createElement('input');
        list.type = 'hidden';
        list.name = 'contact[Produits d\'intérêt]';
        list.setAttribute('data-gb-product-list', '');
        form.appendChild(list);
      }
      list.value = products;

      const note = val('[name="contact[body]"]');
      const acMessage = [
        val('[name="contact[Fonction]"]') ? 'Fonction: ' + val('[name="contact[Fonction]"]') : '',
        val('[name="contact[Banniere]"]') ? 'Bannière: ' + val('[name="contact[Banniere]"]') : '',
        val('[name="contact[Ville / region]"]') ? 'Ville: ' + val('[name="contact[Ville / region]"]') : '',
        val('[name="contact[Nombre de points de vente]"]')
          ? 'Points de vente: ' + val('[name="contact[Nombre de points de vente]"]')
          : '',
        label(form.querySelector('[name="contact[Volume mensuel]"]'))
          ? 'Volume: ' + label(form.querySelector('[name="contact[Volume mensuel]"]'))
          : '',
        products ? 'Produits: ' + products : '',
        note ? 'Contexte:\n' + note : '',
      ]
        .filter(Boolean)
        .join('\n');

      if (typeof window.gbAcSubmit !== 'function') return;
      window.gbAcSubmit({
        source: 'retailer',
        email: val('[name="contact[email]"]'),
        fullname: val('[name="contact[name]"]'),
        phone: val('[name="contact[phone]"]'),
        business: val('[name="contact[Nom du commerce]"]'),
        topic: label(form.querySelector('[name="contact[Type de commerce]"]')),
        message: acMessage,
      }).catch(() => {});
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vote-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var MOCK_TOTAL = 643;
  var MOCK_GOAL = 1000;
  var MOCK_A_PCT = 58;
  var choice = null;

  var stepChoose = document.getElementById('vote-step-choose');
  var stepEmail = document.getElementById('vote-step-email');
  var stepConfirm = document.getElementById('vote-step-confirm');
  var cardA = document.getElementById('vote-card-a');
  var cardB = document.getElementById('vote-card-b');
  var emailForm = document.getElementById('vote-email-form');
  var emailInput = document.getElementById('vote-email-input');
  var emailSubmit = document.getElementById('vote-email-submit');
  var progressFill = document.getElementById('vote-progress-fill');
  var progressCount = document.getElementById('vote-progress-count');
  var resultsEl = document.getElementById('vote-results');

  if (!cardA || !cardB) return;

  function selectCard(c) {
    choice = c;
    cardA.classList.toggle('vote__card--selected', c === 'a');
    cardB.classList.toggle('vote__card--selected', c === 'b');

    setTimeout(function() {
      stepChoose.style.display = 'none';
      stepEmail.style.display = 'block';
      emailInput.focus();
    }, 400);
  }

  cardA.addEventListener('click', function() { selectCard('a'); });
  cardB.addEventListener('click', function() { selectCard('b'); });

  function submitEmail() {
    if (!emailInput.value || !emailInput.validity.valid) {
      emailInput.reportValidity();
      return;
    }
    var total = MOCK_TOTAL + 1;
    stepEmail.style.display = 'none';
    stepConfirm.style.display = 'block';

    var pct = total / MOCK_GOAL * 100;
    setTimeout(function() {
      progressFill.style.width = Math.min(pct, 100) + '%';
    }, 100);
    progressCount.textContent = total + ' / ' + MOCK_GOAL + ' votes';

    var aPct = choice === 'a' ? MOCK_A_PCT + 1 : MOCK_A_PCT;
    var bPct = 100 - aPct;
    resultsEl.innerHTML =
      '<div class="vote__result-item"><div class="vote__result-pct">' + aPct + '%</div><div class="vote__result-label">' + (cardA.querySelector('.vote__card-name')?.textContent || 'Produit A') + '</div></div>' +
      '<div class="vote__result-item"><div class="vote__result-pct">' + bPct + '%</div><div class="vote__result-label">' + (cardB.querySelector('.vote__card-name')?.textContent || 'Produit B') + '</div></div>';
  }

  emailSubmit.addEventListener('click', submitEmail);
  emailForm.addEventListener('submit', function(e) { e.preventDefault(); submitEmail(); });
})();

  } catch(e) { console.error(e); }
})();
})();
